import {
  LIST_HOT_SUB_GAMES,
  LIST_LOBBY_GAME_HARD,
  LIST_SUB_GAME_DEMO,
  PROVIDER_SUB_GAMES,
} from "contants/game-demo";
import { CategoryDetailsType } from "types/game";

import {
  CategoryDetailsResponseType,
  CheckPromotionOnOffType,
  CheckPromotionResponseType,
  loginGameResType,
  loginGameType,
  SubGamePayLoad,
  SubGameResponse,
} from "./type";

const mockProviders: Record<string, CategoryDetailsType[]> = {
  SL: [
    { provider_code: "IBEX", provider_name: "IBEX" },
    { provider_code: "RT", provider_name: "Red Tiger" },
    { provider_code: "SG", provider_name: "Spadegaming" },
    { provider_code: "SPRI", provider_name: "Spribe" },
    { provider_code: "JK", provider_name: "Joker Gaming" },
    { provider_code: "BNG", provider_name: "Booongo" },
    { provider_code: "CQ9", provider_name: "CQ9 Gaming" },
    { provider_code: "HB", provider_name: "Habanero" },
    { provider_code: "JDB", provider_name: "JDB Gaming" },
    { provider_code: "KA", provider_name: "KA Gaming" },
    { provider_code: "PP", provider_name: "Pragmatic Play" },
    { provider_code: "RSG", provider_name: "Royal Slot Gaming" },
    { provider_code: "FC", provider_name: "FC Slots" },
  ],
  LC: [
    { provider_code: "DG", provider_name: "Dream Gaming" },
    { provider_code: "EVO", provider_name: "Evolution Gaming" },
    { provider_code: "PP", provider_name: "Pragmatic Play Live" },
    { provider_code: "SX", provider_name: "Sexy Baccarat" },
    { provider_code: "WM", provider_name: "WM Casino" },
  ],
  SB: [
    { provider_code: "SBO", provider_name: "SBOBET" },
    { provider_code: "UG", provider_name: "United Gaming" },
  ],
  SP: [
    { provider_code: "SBO", provider_name: "SBOBET" },
    { provider_code: "UG", provider_name: "United Gaming" },
  ],
  ES: [
    { provider_code: "TF", provider_name: "TF Gaming" },
    { provider_code: "IA", provider_name: "IA Esports" },
  ],
  FH: [
    { provider_code: "JDB", provider_name: "JDB Fishing" },
    { provider_code: "Joker", provider_name: "Joker Fishing" },
    { provider_code: "CQ9", provider_name: "CQ9 Fishing" },
  ],
  BG: [
    { provider_code: "BL", provider_name: "Bole" },
    { provider_code: "AVIA", provider_name: "AVIATRIX" },
    { provider_code: "PF", provider_name: "Poker Fantasy" },
  ],
  CB: [
    { provider_code: "BL", provider_name: "Bole" },
    { provider_code: "AVIA", provider_name: "AVIATRIX" },
    { provider_code: "PF", provider_name: "Poker Fantasy" },
  ],
  LOTT: [
    { provider_code: "TCG", provider_name: "TCG Lottery" },
    { provider_code: "VR", provider_name: "VR Lottery" },
  ],
};

export const GameApi = {
  loginGame: async (_typename: string, _payload: loginGameType) => {
    return {
      data: {
        status: 0,
        msg: "Success",
        url: "https://demo.game-provider.com",
      } as loginGameResType,
    };
  },
  getSubGame: async (payload: SubGamePayLoad) => {
    // If request is for Hot Games (lobby === 0 / SubGameEnum.HotGame or game_type === "HT" or featured === 1 without provider)
    if (
      payload.lobby === 0 ||
      payload.game_type === "HT" ||
      (payload.featured === 1 && !payload.provider)
    ) {
      return {
        data: {
          status: 0,
          msg: "Success",
          data: LIST_HOT_SUB_GAMES,
          lobby: payload.lobby,
          game_type: payload.game_type,
          totalCount: LIST_HOT_SUB_GAMES.length,
          totalPages: 1,
        } as SubGameResponse,
      };
    }

    const gameType = (payload.game_type || "SL").toUpperCase();
    const providerKey = (payload.provider || "").toUpperCase();

    let gamesList =
      (gameType === "FH"
        ? PROVIDER_SUB_GAMES[`${providerKey}_FH`] ||
          (providerKey === "JOKER" ? PROVIDER_SUB_GAMES["JK_FH"] : undefined)
        : undefined) ||
      PROVIDER_SUB_GAMES[providerKey] ||
      PROVIDER_SUB_GAMES[`${providerKey}_FH`] ||
      PROVIDER_SUB_GAMES[payload.provider || ""];

    if (!gamesList || gamesList.length === 0) {
      const fallbackLobby =
        (LIST_LOBBY_GAME_HARD as any)[gameType] || LIST_SUB_GAME_DEMO;
      const filtered = payload.provider
        ? fallbackLobby.filter(
            (g: any) =>
              !g.provider_code || g.provider_code.toUpperCase() === providerKey
          )
        : fallbackLobby;
      gamesList = filtered.length > 0 ? filtered : fallbackLobby;
    }

    return {
      data: {
        status: 0,
        msg: "Success",
        data: gamesList,
        lobby: payload.lobby,
        game_type: payload.game_type,
        totalCount: gamesList.length,
        totalPages: 1,
      } as SubGameResponse,
    };
  },

  getGameList: async (game_type: string) => {
    const list = mockProviders[game_type] || mockProviders.SL;
    return {
      data: {
        status: 0,
        msg: "Success",
        data: list,
      } as CategoryDetailsResponseType,
    };
  },
  getCheckPromotionOnOffAll: async (_payload: CheckPromotionOnOffType) => {
    return {
      data: {
        status: 0,
        msg: "Success",
      } as CheckPromotionResponseType,
    };
  },
};
